var parkingLocationPagesEU = {
  'de/alicante-flughafen-parken': 'Alicante',
  'de/amsterdam-flughafen-parken': 'Amsterdam',
  'de/barcelona-flughafen-parken': 'Barcelona',
  'de/basel-flughafen-parken': 'Basel',
  'de/bergamo-flughafen-parken': 'Bergamo',
  'de/bologna-flughafen-parken': 'Bologna',
  'de/bordeaux-flughafen-parken': 'Bordeaux',
  'de/bratislava-flughafen-parken': 'Bratislava',
  'de/bruessel-south-charleroi-flughafen-parken': 'Brüssel South-Charleroi',
  'de/bruessel-flughafen-parken': 'Brüssel Zaventem',
  'de/catania-flughafen-parken': 'Catania',
  'de/genf-flughafen-parken': 'Genf',
  'de/genua-flughafen-parken': 'Genua',
  'de/eindhoven-flughafen-parken': 'Eindhoven',
  'de/lugano-flughafen-parken': 'Lugano',
  'de/lyon-flughafen-parken': 'Lyon',
  'de/mailand-linate-flughafen-parken': 'Mailand Linate',
  'de/mailand-flughafen-parken': 'Mailand Malpensa',
  'de/marseille-flughafen-parken': 'Marseille',
  'de/nantes-flughafen-parken': 'Nantes',
  'de/neapel-flughafen-parken': 'Neapel',
  'de/nizza-flughafen-parken': 'Nizza',
  'de/paris-cdg-flughafen-parken': 'Paris Charles de Gaulle',
  'de/paris-orly-flughafen-parken': 'Paris-Orly',
  'de/pisa-flughafen-parken': 'Pisa',
  'de/parken-flughafen-prag': 'Prag',
  'de/rom-flughafen-parken': 'Rom Fiumicino',
  'de/rotterdam-flughafen-parken': 'Rotterdam',
  'de/salzburg-flughafen-parken': 'Salzburg',
  'de/toulouse-flughafen-parken': 'Toulouse',
  'de/treviso-flughafen-parken': 'Treviso',
  'de/valencia-flughafen-parken': 'Valencia',
  'de/venedig-flughafen-parken': 'Venedig',
  'de/verona-flughafen-parken': 'Verona',
  'de/warschau-flughafen-parken': 'Warschau',
  'de/warschau-modlin-flughafen-parken': 'Warschau Modlin',
  'de/wien-flughafen-parken': 'Wien',
  'de/zuerich-flughafen-parken': 'Zürich',
  'de/nurparken': 'Flughafen Parken Deutschland'
}

module.exports = parkingLocationPagesEU



// WEBPACK FOOTER //
// ./shared/config/parkingLocationPagesEU.js